import { faLayerGroup } from '@fortawesome/pro-light-svg-icons/faLayerGroup';
import { faClipboardCheck } from '@fortawesome/pro-light-svg-icons/faClipboardCheck';
import { faArrowProgress } from '@fortawesome/pro-light-svg-icons/faArrowProgress';
import { faArrowsToCircle } from '@fortawesome/pro-light-svg-icons/faArrowsToCircle';
import { faChartBar } from '@fortawesome/pro-light-svg-icons/faChartBar';
import { faHouseBlank } from '@fortawesome/pro-light-svg-icons/faHouseBlank';
import { faChartPie } from '@fortawesome/pro-light-svg-icons/faChartPie';
import { faAlignJustify } from '@fortawesome/pro-light-svg-icons/faAlignJustify';
import { faSquarePollVertical } from '@fortawesome/pro-light-svg-icons/faSquarePollVertical';
import { faCalendarDays } from '@fortawesome/pro-light-svg-icons/faCalendarDays';
import { faBarsFilter } from '@fortawesome/pro-light-svg-icons/faBarsFilter';
import { faCopy } from '@fortawesome/pro-light-svg-icons/faCopy';
import { faCompass } from '@fortawesome/pro-light-svg-icons/faCompass';
import { faBriefcase } from '@fortawesome/pro-light-svg-icons/faBriefcase';
import { faBoxIsometric } from '@fortawesome/pro-light-svg-icons/faBoxIsometric';

import {
  IconAnimation,
  IconRotation,
  SemanticCategory,
  IconLabel,
} from '../types';

export const SEMANTIC_CATEGORY: SemanticCategory = 'asset';
export type SemanticCategoryName = typeof SEMANTIC_CATEGORY;

export const icons = {
  objects: faLayerGroup,
  activities: faClipboardCheck,
  automations: faArrowProgress,
  'smart-connectors': faArrowsToCircle,
  dashboards: faChartBar,
  homepages: faHouseBlank,
  'chart-groups': faChartPie,
  forms: faAlignJustify,
  surveys: faSquarePollVertical,
  broadcasts: faCalendarDays,
  'filter-groups': faBarsFilter,
  'email-templates': faCopy,
  'toolbar-templates': faCompass,
  roles: faBriefcase,
  plugins: faBoxIsometric,
};

export const labels: IconLabel = {
  objects: {
    title: (t) => '',
    description: (t) => t('Objects'),
  },
  activities: {
    title: (t) => '',
    description: (t) => t('Activities'),
  },
  automations: {
    title: (t) => '',
    description: (t) => t('Agentic Workflows'),
  },
  'smart-connectors': {
    title: (t) => '',
    description: (t) => t('Smart Connectors'),
  },
  dashboards: {
    title: (t) => '',
    description: (t) => t('Dashboards'),
  },
  homepages: {
    title: (t) => '',
    description: (t) => t('Homepages'),
  },
  'chart-groups': {
    title: (t) => '',
    description: (t) => t('Chart Groups'),
  },
  forms: {
    title: (t) => '',
    description: (t) => t('Forms'),
  },
  surveys: {
    title: (t) => '',
    description: (t) => t('Surveys'),
  },
  broadcasts: {
    title: (t) => '',
    description: (t) => t('Broadcasts'),
  },
  'filter-groups': {
    title: (t) => '',
    description: (t) => t('Filter Groups'),
  },
  'email-templates': {
    title: (t) => '',
    description: (t) => t('Email Templates'),
  },
  'toolbar-templates': {
    title: (t) => '',
    description: (t) => t('Toolbar Templates'),
  },
  roles: {
    title: (t) => '',
    description: (t) => t('Roles'),
  },
  plugins: {
    title: (t) => '',
    description: (t) => t('Plugins'),
  },
};

export type ValidIcons = keyof typeof icons;

export const rotation: IconRotation = {};

export const animation: IconAnimation = {};
